import React, { Fragment } from 'react';

import BundlePicker from './bundle-picker';
import { Helpers } from '../../../core/src/helpers';
import ImageWithPlaceholder from '../../../shared/components/image-with-placeholder';
import { withError } from '../../../shared/components/error-boundary';
import withPrices from '../../../product/components/product-price/with-product-price';

import '../../css/bundle-container.less';

const defaultIcon = 'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/default-bundle-icon1550621769977.png';
const isProductAvailable = (prices, productSku) =>
    prices.hasOwnProperty(productSku) && prices[productSku].stock !== 0 && !Helpers.isProductOffline(prices[productSku]);

class BundleContainer extends React.PureComponent {
    static whyDidYouRender = true;
    state = {
        priceMap: {
            default: {}
        }
    };

    componentDidMount() {
        const { prices, productSku } = this.props;
        this.fetchBundlePrices();
        if (prices.hasOwnProperty(productSku)) this.setInitialState();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.productSku !== this.props.productSku ||
            prevProps.productsList.length === 0 && this.props.productsList.length > 0
        ) {
            this.fetchBundlePrices();
        }
        if (prevProps.productSku !== this.props.productSku || prevProps.prices !== this.props.prices) {
            this.setInitialState();
        }
    };

    fetchBundlePrices = () => {
        const ids = this.props.productsList.reduce((ids, prd) => {
            ids.push(prd.itemId);
            return ids;
        }, []);
        this.props.fetchPrices(ids);
    };

    setInitialState = () => {
        const priceMap = this.buildPriceMap(this.props.bundles);
        this.setState({ priceMap });
    }

    calculateTotalPrice = (selectionMap) => {
        const newTotalPrice = Object.assign({}, this.state.priceMap.default);
        Object.keys(selectionMap).forEach((sku) => {
            if (selectionMap[sku] && this.state.priceMap[sku]) {
                newTotalPrice.regularPrice = (parseFloat(newTotalPrice.regularPrice) + this.state.priceMap[sku].regularPrice).toFixed(2);
                newTotalPrice.salePrice = (parseFloat(newTotalPrice.salePrice) + this.state.priceMap[sku].salePrice).toFixed(2);
            }
        });
        return newTotalPrice;
    }

    findLowestPriceProduct = (products, priceMap) => {
        const compare = (a, b) => {
            let aPrice = priceMap[a.sku] ? priceMap[a.sku].salePrice : a.listPrice;
            let bPrice = priceMap[b.sku] ? priceMap[b.sku].salePrice : b.listPrice;
            if (aPrice < bPrice) {
                return -1;
            }
            if (aPrice > bPrice) {
                return 1;
            }
            return 0;
        }
        return products.sort(compare)[0].sku;
    }

    buildPriceMap = (bundles) => {
        const { prices, productSku, metaData = {} } = this.props;
        const { xsell = [] } = metaData;
        let priceMap = {
            default: {}
        };
        if (prices.hasOwnProperty(productSku)) {
            priceMap.default = {
                regularPrice: parseFloat(prices[productSku].regularPrice),
                salePrice: parseFloat(prices[productSku].salePrice)
            };

            bundles.reduce((priceMap, bundle) => {
                let bundleTotalPrice = {
                    regularPrice: 0,
                    salePrice: 0
                };
                const { promoType, promoValue } = xsell[bundle.bundleIndex] || {};
                let isAddOnMissing = false;
                let onSalePrice;
                let lowestPriceProduct = this.findLowestPriceProduct(bundle.products, prices);
                bundle.products.forEach((product) => {
                    if (isProductAvailable(prices, product.sku)) {
                        if (promoType === 'ink_offer' && promoValue && product.sku === lowestPriceProduct && product.metadata.quantity) {
                            onSalePrice = parseFloat(prices[product.sku].regularPrice * (1 - promoValue)) + parseFloat(prices[product.sku].regularPrice * (product.metadata.quantity - 1));
                        } else {
                            onSalePrice = parseFloat(prices[product.sku].salePrice * (product.metadata.quantity || 1));
                        }
                        bundleTotalPrice.regularPrice = bundleTotalPrice.regularPrice + parseFloat(prices[product.sku].regularPrice * (product.metadata.quantity || 1));
                        bundleTotalPrice.salePrice = bundleTotalPrice.salePrice + onSalePrice;
                    } else {
                        isAddOnMissing = true;
                    }
                });
                if (isAddOnMissing) bundleTotalPrice = null;
                priceMap[bundle.bundleIndex] = bundleTotalPrice;
                return priceMap;
            }, priceMap);
        }
        return priceMap;
    }

    render() {
        const { bundles = [], metaData = {}, className, HeaderComponent = null, bundleItemComponent = null, ariaLabel = '' } = this.props;
        const { icon, headline, subline, valuemsg, upsell = true } = metaData;
        const { priceMap } = this.state;
        const iconSrc = Helpers.getCDNUrl(icon, defaultIcon, 75);
        return (
            <div className={`bundle-wrapper${className ? ` ${className}` : ''}`}>
                <div tabIndex={0} aria-label={ariaLabel ? ariaLabel : 'Bundle Options'} className='bundle-container'>
                    <BundlePicker {...this.props}
                        bundles={bundles}
                        priceMap={priceMap}
                        calculateTotalPrice={this.calculateTotalPrice}
                    >
                        {
                            (props) =>
                                <div className='bundle-header'>
                                    {
                                        HeaderComponent ? <HeaderComponent {...props} /> :
                                            <Fragment>
                                                <div className='header-logo'>
                                                    <ImageWithPlaceholder className='logo-img' src={iconSrc} />
                                                </div>
                                                <div className='header-title'>
                                                    <h3>{headline}</h3>
                                                    <h4 dangerouslySetInnerHTML={Helpers.createMarkup(subline)}></h4>
                                                    {valuemsg && <span className="bundle-promo">{valuemsg}</span>}
                                                </div>
                                            </Fragment>
                                    }
                                </div>
                        }
                    </BundlePicker>
                </div>
            </div>
        );
    }
}

export { BundleContainer as RawBundleContainer }
export default withError(withPrices(BundleContainer));
